import { API } from 'aws-amplify'
import { DataStore, SortDirection } from '@aws-amplify/datastore'

import {
  updateDgtPdOrderOperation
} from '../graphql/mutations'
import {
  operationByOrderIdAndNo,
  getDgtPdOrderOperation
} from '../graphql/queries'
import { DgtPdOrderOperation, DgtPdWorkCenter } from '../models'
import { OrderStatusCode } from '../constants/Enum'
import { OrderOperation } from '../components/types'
import { MachineCategory } from '../models'

export const getActiveOperations = async (orderId: string) : Promise<OrderOperation[]> => {
  const listResult: any = await API.graphql({
    query: operationByOrderIdAndNo,
    variables: { 
      productionOrderId: orderId,
      filter: {
        _deleted: { ne: true },
        active: { eq: true }
      }
    }
  })
  const operations: DgtPdOrderOperation[] = 
    listResult.data?.operationByOrderIdAndNo.items
  
  const wcPromises = operations.map(op => {
    const wcId = op.actualWorkCenterId ? op.actualWorkCenterId : op.workCenterId
    return DataStore.query(DgtPdWorkCenter, wcId)
  })
  
  const masterWorkCenters = (await Promise.all(wcPromises)).filter(wc => wc) // filter not null
  const joinedOperations = operations.map(op => {
    const foundWc = masterWorkCenters.find(wc => wc!.id === (op.actualWorkCenterId || op.workCenterId))
    if (foundWc === undefined) return { ...op }
    return { 
      ...op,
      isRequiredFGInspect: foundWc.isRequiredFGInspect === null ? false : foundWc.isRequiredFGInspect,
      isRequiredManHour: foundWc.isRequiredManHour === null ? true : foundWc.isRequiredManHour,
      isRequiredBatchLotNo: foundWc.isRequiredBatchLotNo === null ? true : foundWc.isRequiredBatchLotNo,
      machineCategory: foundWc.machineCategory as MachineCategory
    }
  })
  return joinedOperations
}

export const updateStatusToDrafted = async (operationId: string, username: string) => {
  const getResult: any = await API.graphql({
    query: getDgtPdOrderOperation,
    variables: { id: operationId }
  })
  if (getResult.data?.getDgtPdOrderOperation) {
    const version = getResult.data?.getDgtPdOrderOperation._version
    const now = new Date()
    return API.graphql({
      query: updateDgtPdOrderOperation,
      variables: { input: {
        _version: version, 
        id: operationId,
        status: OrderStatusCode.DRAFTED,
        draftedDate: now.toISOString(),
        draftedBy: username
      }}
    })
  }
  return null
}

export const updateStatusToInProgress = async (operationId: string, username: string) => {
  const getResult: any = await API.graphql({
    query: getDgtPdOrderOperation,
    variables: { id: operationId }
  })
  if (getResult.data?.getDgtPdOrderOperation) {
    const version = getResult.data?.getDgtPdOrderOperation._version
    return API.graphql({
      query: updateDgtPdOrderOperation,
      variables: { input: {
        _version: version, 
        id: operationId,
        status: OrderStatusCode.IN_PROGRESS,
        draftedDate: null,
        draftedBy: null
      }}
    })
  }
  return null
}

export const getDataStoreOperations = async (orderId: string) : Promise<OrderOperation[]> => {
  const operations = await DataStore.query(DgtPdOrderOperation,
    op => op.productionOrderId('eq', orderId), { 
      sort: op => op.operationNo(SortDirection.ASCENDING) 
    });
  
  const wcPromises = operations.map(op => {
    const wcId = op.actualWorkCenterId ? op.actualWorkCenterId : op.workCenterId
    return DataStore.query(DgtPdWorkCenter, wcId)
  })
  
  const masterWorkCenters = (await Promise.all(wcPromises)).filter(wc => wc) // filter not null

  return operations.map(op => {
    const foundWc = masterWorkCenters.find(wc => wc!.id === (op.actualWorkCenterId || op.workCenterId))
    if (foundWc === undefined) return { ...op }
    return { 
      ...op,
      isRequiredFGInspect: foundWc.isRequiredFGInspect === null ? false : foundWc.isRequiredFGInspect,
      isRequiredManHour: foundWc.isRequiredManHour === null ? true : foundWc.isRequiredManHour,
      isRequiredBatchLotNo: foundWc.isRequiredBatchLotNo === null ? true : foundWc.isRequiredBatchLotNo,
      machineCategory: foundWc.machineCategory as MachineCategory
    }
  })
}